import React                from 'react';
import { useTranslation }   from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import Box                  from '@material-ui/core/Box';
import Link                 from './Link';

const CommunityHelp = () => {
	const { t } = useTranslation();
	return (
		<Grid container spacing={1} direction='column'>
			<Grid item xs={12}>
				<Box my={2}>
					<Typography variant='h4'>{t('footer_nav_com')}</Typography>
				</Box>
			</Grid>
			<Grid item xs={12}>
				<Link href={`${process.env.REACT_APP_SHELL_URL}/blog`}>
					{t('footer_nav_com_t3')}
				</Link>
			</Grid>
			<Grid item xs={12}>
				<Link href={`${process.env.REACT_APP_SHELL_URL}/tutorial`}>
					{t('footer_nav_com_t4')}
				</Link>
			</Grid>
			<Grid item xs={12}>
				<Link href={`${process.env.REACT_APP_SUPPORT_SHELL_URL}`}>
					{t('support_title')}
				</Link>
			</Grid>
		</Grid>
	);
};

export default CommunityHelp;
